var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/** Show an HTML input overlay to edit a diagram node label (draw.io-style). */
export function showLabelEditor(app, node, onCommit) {
    var el = app['renderer'].getElement();
    var rect = el.getBoundingClientRect();
    var b = node.getBounds();
    var parent = node.parent;
    var wx = node.x + b.x;
    var wy = node.y + b.y;
    if (parent) {
        wx += parent.x;
        wy += parent.y;
    }
    var screen = app.camera.worldToScreen(wx, wy);
    var input = document.createElement('input');
    input.type = 'text';
    input.value = extractLabel(node);
    Object.assign(input.style, {
        position: 'fixed',
        left: "".concat(rect.left + screen.x, "px"),
        top: "".concat(rect.top + screen.y, "px"),
        minWidth: "".concat(Math.max(80, b.width), "px"),
        padding: '4px 8px',
        fontSize: '12px',
        fontFamily: 'Inter, system-ui, sans-serif',
        border: '2px solid #38bdf8',
        borderRadius: '6px',
        background: '#1e293b',
        color: '#f1f5f9',
        zIndex: '10000',
        outline: 'none',
    });
    document.body.appendChild(input);
    input.focus();
    input.select();
    var commit = function () {
        var v = input.value.trim();
        if (v)
            onCommit(v);
        input.remove();
    };
    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter')
            commit();
        if (e.key === 'Escape')
            input.remove();
    });
    input.addEventListener('blur', commit);
}
function extractLabel(node) {
    var e_1, _a;
    try {
        for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            if (child.type === 'text' && 'text' in child) {
                return child.text;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return '';
}
